<section class="settings-card">
    <header class="card-header">
        <div class="card-icon">
            <mat-icon class="material-icons-outlined" aria-hidden="true">tune</mat-icon>
        </div>
        <div class="card-copy">
            <h2 appLocalizationPopupDirective localizationCode="FormSettings">{{ 'FormSettings' | translate: {Default: "Form settings"} }}</h2>
            <p>{{ 'FormSettingsDescription' | translate: {Default: "Name the form and choose the table it saves to."} }}</p>
        </div>
    </header>

    <ng-container *ngIf="!form; else loadedForm">
        <ngx-skeleton-loader count="3" [theme]="{ 'height.px': 48, 'border-radius': '10px' }"></ngx-skeleton-loader>
    </ng-container>

    <ng-template #loadedForm>
        <form class="settings-form" [formGroup]="form" (ngSubmit)="save()">
            <div class="settings-section">
                <div class="section-heading">
                    <span class="section-label">{{ 'FormSettingsFormName' | translate: {Default: "Form name"} }}</span>
                    <p>{{ 'FormSettingsFormNameHint' | translate: {Default: "Add a translation for each language your users see."} }}</p>
                </div>

                <app-localization-text-form-field
                    [formElement]="nameField"
                    [parentGroup]="form"
                    [cultures]="cultures"
                    [showTitle]="false"
                    (emitAddtoFormArray)="addLocalizationFromComponent($event)"
                    (emitDeleteFromFormArray)="deleteLocalizationFromComponent($event)"
                ></app-localization-text-form-field>
            </div>

            <div class="settings-section">
                <div class="section-heading">
                    <span class="section-label">{{ 'FormSettingsDataSource' | translate: {Default: "Data source"} }}</span>
                    <p>{{ 'FormSettingsDataSourceHint' | translate: {Default: "The table decides which fields you can link elements to."} }}</p>
                </div>

                <mat-form-field appearance="fill" subscriptSizing="dynamic">
                    <mat-label>{{ 'RootTable' | translate: {Default: "Root table"} }}</mat-label>
                    <mat-select disableOptionCentering formControlName="table">
                        <app-select-search [search]="tableSearch"></app-select-search>
                        <mat-option *ngFor="let table of tableSearch.options" [value]="table.id">{{table.name}}</mat-option>
                    </mat-select>
                    <mat-icon class="material-icons-outlined" matPrefix aria-hidden="true">table_chart</mat-icon>
                </mat-form-field>
            </div>

            <div class="card-footer">
                <span class="save-state" *ngIf="form.dirty">
                    <span class="dot"></span>
                    {{ 'UnsavedChanges' | translate: {Default: "Unsaved changes"} }}
                </span>
                <button
                    type="submit"
                    class="save-button"
                    mat-flat-button
                    setColor="primaryColour"
                    color="primary"
                    [disabled]="form.pristine || form.invalid || saving">
                    {{ 'SaveChanges' | translate: {Default: "Save changes"} }}
                </button>
            </div>
        </form>
    </ng-template>
</section>
